jQuery(document).foundation();

jQuery(document).ready(function() {
	jQuery('input, textarea').on('keydown', function() {
		jQuery(this).parent('.input').addClass('focus');
	});

	jQuery(window).on('load', function() {
		if (document.documentElement.clientWidth >= 600) {
			var boxHeight = 0;
	
			jQuery('[class*="box--lvl"]').each(function( index ) {
				var oneBoxHeight = jQuery(this).outerHeight();
				if (oneBoxHeight > boxHeight) {
					boxHeight = oneBoxHeight;
				}
			});
			
			jQuery('[class*="box--lvl"]').each(function( index ) {
				jQuery(this).css('min-height', boxHeight);
			});
		}
	});

	jQuery("#latest-posts li").shuffle();
	jQuery("#latest-posts").owlCarousel({
		loop: true,
		nav: true,
		nestedItemSelector: 'wp-block-latest-posts__list > li',
		itemElement: 'ul',
		responsiveClass: true,
		responsive: {
			0: {
			  items: 1,
			  margin: 20
			},
  
			540: {
			  items: 2,
			  margin: 50
			}
		}
	});

	jQuery("#experiences_slider").owlCarousel({
		loop: false,
		nav: true,
		dots: false,
		margin: 20,
		responsiveClass: true,
		responsive: {
			0: {
			  items: 2
			},
  
			540: {
			  items: 3
			},

			740: {
				items: 4
			},

			960: {
				items: 5,
				margin: 32
			}
		}
	});
  });

  (function($){
    $.fn.shuffle = function() {
 
        var allElems = this.get(),
            getRandom = function(max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function(){
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
           });
 
        this.each(function(i){
            $(this).replaceWith($(shuffled[i]));
        });
 
        return $(shuffled);
 
    };
})(jQuery);